let loadMoreButton = {
	init() {
		this.loadButton();
	},
	loadButton() {

		// Updating the text this route in case powertools filter is selected
		//$('.pagination-item-total').text($('.grid--view-items').attr('data-item-count') + ' results');
		// Collection page load more pagination
		//TODO: Cole.  Rather create these as object properties at the begining of the function
		var loadMoreButton = document.querySelector('.load-more-btn');
		var loadMoreContainer = document.querySelector('.load-more');
		if (loadMoreButton) {
			loadMoreButton.addEventListener('click', function (evt) {

				let currentPage = parseInt(this.dataset.currentPage);
				let totalPages = parseInt(this.dataset.totalPages);
				let paginationItemCount = parseInt(this.dataset.itemCount);
				const collectionItemCount = parseInt(this.dataset.collectionCount);
				this.setAttribute("disabled", true);
				this.querySelector('[loader]').classList.remove("hide");

				//check for query string in url
				let search = ''
				if (window.location.search != '') {
					search = window.location.search.replace('?', '')
				}

				// Update the attributes needed for the next click event
				currentPage = currentPage + 1;
				let next_url = window.location.pathname + '?page=' + currentPage;
				if (search != '') {
					next_url = next_url + '&' + search
				}
				this.dataset.nextUrl == next_url;
				loadMoreButton.setAttribute('data-current-page', currentPage);

				//uncomment the below if the counter below the load more button is to be showed
				//const counter = document.querySelector(".pagination-item-count");
				$.ajax({
					url: next_url,
					type: 'GET',
					dataType: 'html',
					success: function (responseHTML) {
						$('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
					},
					complete: function () {
						//$('.pagination-item-total').text($('.grid--view-items').attr('data-item-count') + ' results')
						if (currentPage < totalPages) {
							loadMoreButton.removeAttribute("disabled");
							loadMoreButton.querySelector('[loader]').classList.add("hide");
							$('.grid--view-items').attr('data-item-total', paginationItemCount * currentPage);
							section_loader.init(document.querySelector('.grid--view-items'));
						} else {
							loadMoreContainer.classList.add("hide");
						}

						if (shipping_calculator.enabled && document.body.classList.contains('temp-collection')) {
							shipping_calculator.init();
						}
					}
				})
			});
		}
	}
}
/*
===== #document_ready_function ==== */
// Wait for the document to load
function ready(callback) {
	if (document.readyState != 'loading') callback();
	else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
}
ready(function () {
	loadMoreButton.init();
});